<!--隐私协议-->
<template>
    <div class="services">
        <div class="container">

            <p>1.接受条款</p>
            <p>爱驿站应用（以下简称“爱驿站”）由江苏爱驿站信息科技有限公司（以下简称“江苏爱驿站”）开发，根据以下服务条款为您提供服务。江苏爱驿站在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《身份认证协议》。</p>
            <p>2.若您点击“人脸检测识别”则标识您本人自愿同意使用人脸认证功能并同意以下授权；</p>
            <p>3.您知晓并同意，真人认证为通过技术手段采取使用者的面部信息，仅用于确保该账号使用者本人，但请您理解由于技术限制原因，仍存在无法认证的可能性；</p>
            <p>4.您同意并授权我们开启您设备的摄像头，采集您的面部信息；</p>
            <p>5您同意并授权我们对外展示您的真人认证标签；</p>
            <p>个人信息使用期限：</p>
            <p>（1）我们自您使用服务时获取到您个人信息之日起至您个人信息之日起至您注销账户前会存储并保留您的个人信息；</p>
            <p>（2）在您的个人信息超出必要保留期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定除外；</p>
            <p>（3）当我们的产品或服务发生停止运营的情况的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>

            <div class="footer">
                <p>江苏爱驿站信息科技有限公司</p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
    <!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.services{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
    }
}
</style>
<script setup lang="ts">
</script>